export enum HomeProductsTypes {
  GET_HOME_PRODUCTS_START = 'GET_HOME_PRODUCTS_START',
  GET_HOME_PRODUCTS_FAILED = 'GET_HOME_PRODUCTS_FAILED',
  GET_HOME_PRODUCTS_SUCCESS = 'GET_HOME_PRODUCTS_SUCCESS',
}
